// i18n.js 国际化配置文件
import Vue from 'vue'
import Element from '@supaur/element-ui-rtl'
import VueI18n from 'vue-i18n'
import esLocale from '@supaur/element-ui-rtl/lib/locale/lang/es'
import zhLocale from '@supaur/element-ui-rtl/lib/locale/lang/zh-CN'
import enLocale from '@supaur/element-ui-rtl/lib/locale/lang/en'
import arLocale from '@supaur/element-ui-rtl/lib/locale/lang/ar'

const storageOptions = {
  namespace: 'sp__'
}
// 前端本地的lang
export const currentLang = getLang()

export const isZh = currentLang === 'zh-cn'
export const isMx = currentLang === 'es-mx'
export const isEn = currentLang === 'en-xa'
export const isSaudi = currentLang === 'ar-sa'

function getLsValue(key) {
  return JSON.parse(localStorage.getItem(`${storageOptions.namespace}${key}`))
}

function getBrowerLang() {
  let lang
  if (navigator.languages && navigator.languages.length > 0) {
    lang = navigator.languages[0]
  } else {
    lang = navigator.language || navigator.browserLanguage
  }
  return lang === 'zh' ? 'zh-cn' : lang.toLowerCase()
}

export function getLang() {
  const lang = getLsValue('LANG') || {}
  return lang.value || getBrowerLang()
}

Vue.use(VueI18n)
esLocale.el.datepicker.startDate = 'Fecha Inicial'

const messages = {
  'zh-cn': Object.assign(require('../locale/zh'), zhLocale),
  'es-mx': Object.assign(require('../locale/spa'), esLocale),
  // 'en-us': Object.assign(require('../locale/en'), enLocale),
  'en-xa': Object.assign(require('../locale/en'), enLocale),
  'ar-sa': Object.assign(require('../locale/saudi'), arLocale)
}

const i18n = new VueI18n({
  locale: currentLang,
  messages
})

Vue.use(Element, {
  i18n: (key, value) => i18n.t(key, value)
})

export default i18n



// WEBPACK FOOTER //
// ./src/i18n.js